import { configureStore } from '@reduxjs/toolkit';
import authorizationReducer from './authorization/authorizationSlice';

export const store = configureStore({
    reducer: {
        authorization: authorizationReducer,
    },
});
